import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MetricItem {
  label: string;
  value: string;
  icon: string;
  color: string;
}

interface MetricsDashboardProps {
  metrics: MetricItem[];
}

const MetricsDashboard = ({ metrics }: MetricsDashboardProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => (
        <div
          key={index}
          className="relative bg-card border border-border rounded-xl p-6 overflow-hidden group hover:border-primary/50 transition-all duration-500 hover:shadow-premium"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          
          <div className="relative flex items-start justify-between">
            <div className="flex-1">
              <p className="text-sm font-semibold text-muted-foreground mb-2">
                {metric.label}
              </p>
              <p className={`text-3xl font-display font-bold ${metric.color}`}>
                {metric.value}
              </p>
            </div>
            <div className={`flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br ${metric.color === 'text-primary' ? 'from-primary/20 to-primary/5' : metric.color === 'text-accent' ? 'from-accent/20 to-accent/5' : metric.color === 'text-success' ? 'from-success/20 to-success/5' : 'from-secondary/20 to-secondary/5'} flex items-center justify-center group-hover:scale-110 transition-transform duration-500`}>
              <Icon name={metric.icon as any} size={24} className={metric.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsDashboard;